<template>
  <div class="modal">
    <div class="top" :class="[{ 'triviabox-bg': isTriviaboxPage }]">
      <button
        class="close-btn"
        @click="onCloseBtnClick"
      >
        <FontAwesomeIcon :icon="icon" />
      </button>
    </div>

    <div class="body" :class="[{ 'triviabox-border-none': isTriviaboxPage }]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: 'xmark' }
  },

  computed: {
    isTriviaboxPage() {
      return this.$route && this.$route.path && this.$route.path.startsWith('/triviabox');
    }
  },

  methods: {
    onCloseBtnClick() {
      this.$emit('hide');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  background: #ffffff;
  position: relative;

  .top {
    border: none;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    z-index: 1;

    .close-btn {
      color: #fff;
      background: none;
      border: none;
      cursor: pointer;
      margin: 10px 10px 2px 2px;
      font-size: 24px;
    }
  }

  .triviabox-bg {
    background: #000000 !important;
  }

  .body {
    // border-bottom: 8px solid $thd-orange;
    border-bottom: none;
  }

  .triviabox-border-none {
    border-bottom: none !important;
  }
}
</style>
